/**
 * illm-common.js
 * Version: 1.0.0
 */

const illm = { common:{} };

/**
 * PC、スマホのプレークポイント定数
 */
illm.common.breakpoint = {
  pc: 750,        // PC判定の基準幅
  sp: 749         // SP判定の基準幅
};

/**
 * PC判定
 */
illm.common.isPC = function() {
  return window.matchMedia(`(min-width: ${illm.common.breakpoint.pc}px)`).matches;
};

/**
* スマートフォン判定
*/
illm.common.isSmartphone = function() {
 return window.matchMedia(`(max-width: ${illm.common.breakpoint.sp}px)`).matches;
};

/**
 * 現在のページのURLを取得(絶対パス)
 */
illm.common.getCurrentUrl = function() {
  return `${document.location.protocol}//${document.location.host}${document.location.pathname}`;
};

/**
 * HOMEのURLを取得（pathnameからの絶対パス）
 */
illm.common.getHomeUrlPathName = () => '/';

/**
 * HOMEのURLを取得(絶対パス)
 */
illm.common.getHomeUrl = function() {
  const pathname = illm.common.getHomeUrlPathName();
  return `${document.location.protocol}//${document.location.host}${pathname}`;
};

/**
 * トップページ判定
 */
illm.common.isPageTop = function() {
  return Util.isPageRegex('^/\/?$');
};

/**
 * 現在時刻をサーバーから取得
 */
illm.common.getServerDate = function() {
  const url = window.location.href;
  return fetch( url )
  .then(res => {
    if (!res.ok) throw new Error( 'fetch failed' );
    // レスポンスヘッダーから時刻を取得
    return new Date( res.headers.get('Date') );
  })
  .catch(error => {
    // エラー時はブラウザの現在時刻を返す
    return new Date();
  });
};

/**
 * スムーススクロール
 */
illm.common.smoothScroll = function() {
  // ページ内リンクを全て取得（hrefが#で始まるもの）
  const links = document.querySelectorAll('a[href^="#"]');
  // 各リンクにクリックイベントを追加
  links.forEach(function(link) {
    link.addEventListener('click', function(e) {
      // デフォルトのリンクを防止
      e.preventDefault();
      // href属性からターゲット要素を取得
      // hrefが空や"#"の場合はページトップ（html要素）にスクロール
      const target = document.querySelector(link.getAttribute('href') || 'html');
      if (!target) {
        return; // ターゲットが存在しなければ処理を終了
      }
      // ネイティブのスムーズスクロールを実行
      target.scrollIntoView({ behavior: 'smooth' });
    });
  });
};

/**
* クッキーを設定する関数
*
* @param {string} name - 設定したいクッキーの名前
* @param {string} value - 設定したいクッキーの値
* @param {object} options - オプション
*    options.days      {number} 有効日数（整数）
*    options.expiresMs {number} 有効期限（ミリ秒単位）
*                               例）1時間 = 60 * 60 * 1000
*                               例）10分  = 10 * 60 * 1000
*    options.session   {boolean} trueならセッションCookie
*/
illm.common.setCookie = function(name, value, options) {
  if (options.session) {
    // セッションCookie（ブラウザ閉じたら消える）
    document.cookie = `${name}=${value};path=/`;
    return;
  }

  let expires = "";
  if (options.expiresMs) {
    // ミリ秒指定の場合
    const date = new Date();
    date.setTime(date.getTime() + options.expiresMs);
    expires = "expires=" + date.toUTCString();
  } else if(options.days) {
    // 日数指定の場合
    const date = new Date();// 現在日時を取得
    // 日数をミリ秒に変換
    date.setTime(date.getTime() + (options.days * 24 * 60 * 60 * 1000));
    // Cookie用のexpires文字列を生成（UTC形式で指定）
    expires = "expires=" + date.toUTCString();
  }
  // 有効期限付きで cookie を設定
  document.cookie = `${name}=${value};${expires};path=/`;
};

/**
* クッキーを取得する関数
*
* @param {string} cookieName - 取得したいクッキーの名前
*/
illm.common.getCookie = function(cookieName) {
  const cookiePrefix = cookieName + "=";
  const allCookiesArray = document.cookie.split(';');// すべてのクッキーをセミコロンで分割
  // すべてのクッキーをループでチェック
  for (let i = 0; i < allCookiesArray.length; i++) {
    let cookie = allCookiesArray[i].trim();// 前後のスペースを削除
    // クッキー名が一致するものを探す
    if (cookie.indexOf(cookiePrefix) === 0) {
    // クッキーの値を返す
    return cookie.substring(cookiePrefix.length);
    }
  }
  // クッキーが見つからない場合はnullを返す
  return null;
};

/**
* リサイズ時に画面幅が指定のブレークポイント以下の場合に指定した処理を実行
* 
* @param {number} breakpoint - 判定する幅（例えば、749px以下でスマホ）
* @param {function} callback - 画面幅がブレークポイント以下になった時に実行する処理
*/
illm.common.onResize = function(breakpoint, callback) {
  let isExecuted = false; // 一度だけ実行されたかどうかを示すフラグ

  function checkSize() {
    if (window.innerWidth <= breakpoint) {
      if (!isExecuted) {
        callback();// 初回だけコールバックを実行
        isExecuted = true;// 実行済みに設定
      }
    } else {
      // サイズが大きくなったら再度実行できるようリセット
      isExecuted = false;
    }
  }

  // 初回判定
  checkSize();

  // リサイズ時にもチェック
  window.addEventListener('resize', function() {
    checkSize();
  });
};

/**
* 文字数制限（半角文字は 1 バイト、全角文字は 2 バイト）
* 
* @param {string|HTMLElement|jQuery} target - 対象の input 要素
* @param {number} maxBytes - 最大バイト数
*/
illm.common.enforceByteLimit = function(target, maxBytes) {
  let value = target.value;// 入力値を取得
  let currentBytes = 0; // 現在のバイト数
  let charBytes; // 各文字のバイト数
  let result = ''; // 制限内の文字列

  for(let i=0; i < value.length; i++){
    // 半角か全角かを判定
    if( value.charCodeAt(i) <= 127 ){
      charBytes = 1;
    }else {
      charBytes = 2;
    }
    // 最大バイト数を超えるならそれ以上は追加しない
    if( currentBytes + charBytes > maxBytes ){
      break;
    }
    currentBytes += charBytes;
    result += value[i];
  }
  // 制限以内の文字列だけを再セット
  target.value = result;
};

/**
 * 日付に関する共通関数
 */
illm.common.dateUtil = {
  /**
  * 開始日から指定日数後の終了日を返す
  * @param {Date} startDate - 開始日（Dateオブジェクト）
  * @param {number} periodDays - 開始日からの期間（日数）
  * @param {boolean} inclusive - 終了日を含むかどうか（デフォルト: true）
  * @returns {Date} 指定日数後の終了日時（その日の23:59:59.999に設定されたDateオブジェクト）
  * 例: start=2025/08/20, days=30 → 2025/09/19 23:59:59.999
  */
  getEndDateByDays: function(startDate, periodDays, inclusive = true) {
    // 開始日から periodDays 日後の日時を作成
    const periodEndDate = new Date(startDate.getTime() + periodDays * 24 * 60 * 60 * 1000);
    // 終了日を含める（その日の23:59:59.999を設定）
    if (inclusive) {
      periodEndDate.setHours(23, 59, 59, 999);
    // 終了日を含めない（翌日の00:00:00.000を設定）
    }else{
      periodEndDate.setHours(0, 0, 0, 0);
      periodEndDate.setDate(periodEndDate.getDate() + 1);
    }
    // 終了日時を返す
    return periodEndDate;
  },

  /**
  * 日付が指定した期間内に含まれるか判定
  * @param {Date} target - 判定対象の日付
  * @param {Date} startDate - 開始日（含む）
  * @param {Date} endDate - 終了日（含む）
  * @param {boolean} inclusiveEnd - 終了日を含むかどうか（デフォルト: true）
  * @returns {boolean} - 期間内なら true、期間外なら false
  */
  isWithinRange: function(targetDate, startDate, endDate, inclusiveEnd = true) {
    // 判定対象の日付をミリ秒に変換
    const targetTimeMs = targetDate.getTime();
    // 開始日をミリ秒に変換
    const startTimeMs = startDate.getTime();
    // 終了日をミリ秒に変換
    const endDateAdjusted = new Date(endDate.getTime());
    if (!inclusiveEnd) {
      // 終了日を含まない場合 → 前日の23:59:59.999
      endDateAdjusted.setDate(endDateAdjusted.getDate() - 1);
    }
    const endTimeMs = endDateAdjusted.getTime();

    // 開始日を含むかどうかで判定
    const isAfterStart = targetTimeMs >= startTimeMs;
    // 終了日を含むかどうかで判定
    const isBeforeEnd = targetTimeMs <= endTimeMs;

    // 両方の条件を満たす場合のみ true を返す
    return isAfterStart && isBeforeEnd;
  }
};
